import type { FieldError } from 'react-hook-form'

export function translateError(t: (key: string, defaultValue: string) => string, error: FieldError | undefined): string | undefined {
  if (!error?.message) return undefined
  return t(error.message, error.message)
}
